/**
 * Applications API Service
 */

import api from "../client";
import { ENDPOINTS } from "../endpoints";
import type { StormApplication, StormApplicationsResponse } from "../types";

export const applicationsApi = {
  /**
   * Get all storm applications available for the organization
   * The organization is determined by the 'org-name' header set by the API client
   */
  list: async (): Promise<StormApplication[]> => {
    const response = await api.get<StormApplicationsResponse>(
      ENDPOINTS.STORM_APPLICATIONS,
    );
    return response.items;
  },
};

export default applicationsApi;
